export default __webpack_public_path__ + "static/media/mci.bd4bedd1.svg";